/*
 * Drawer carrello Small Giants: sostituisce l'app UpCart.
 * Stesso DOM e stesse classi di UpCart (CSS in sg-upcart.css), disegnato da /cart.js.
 * Soglie, premi, testi italiani e regole upsell arrivano dai setting del tema
 * (snippets/sg-upcart-config.liquid -> <script id="sg-upcart-config">). Qui non ci sono valori di business.
 * Testi EN/DE: fallback nel dizionario D (le chiavi di traduzione del tema non sono ancora caricabili).
 * Si apre da solo dopo ogni aggiunta al carrello: fetch/XHR verso /cart/add, form nativi /cart/add
 * (es. landing con <product-form> senza JS), drawer Dawn (open/renderContents dirottati qui).
 * Valute locali dei mercati: soglie convertite con Shopify.currency.rate, importi nel formato Shopify della valuta.
 */
(function () {
  'use strict';
  if (window.sgUpcart) return;
  var cfgEl = document.getElementById('sg-upcart-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var ROOT = CFG.root || '/';
  var LOC = String(CFG.locale || 'it').toLowerCase().split('-')[0];

  /* ---- testi: italiano da setting, EN/DE da dizionario (fallback) ---- */
  var D = {
    en: {
      title: 'Cart • {{cart_quantity}} Items', titleOne: 'Cart • 1 Item', checkout: 'Checkout • {{total_price}}', empty: 'Your cart is empty',
      add: 'Add to Cart', discounts: 'Discounts', save: 'Save', upsellTitle: 'Still Hungry? Have a look at these',
      after: 'Discounts and free shipping unlocked :)',
      tierLabel: ['Free Shipping', '10% off'],
      tierBefore: ['{AMOUNT} away from free shipping!', '{AMOUNT} away from 10% off']
    },
    de: {
      title: 'Warenkorb • {{cart_quantity}} Produkte', titleOne: 'Warenkorb • 1 Produkt', checkout: 'Zur Kasse • {{total_price}}', empty: 'Dein Warenkorb ist leer',
      add: 'Hinzufügen', discounts: 'Rabatte', save: 'Du sparst', upsellTitle: 'Noch Hunger? Schau mal hier',
      after: 'Rabatte und kostenloser Versand freigeschaltet :)',
      tierLabel: ['Kostenloser Versand', '10 % Rabatt'],
      tierBefore: ['Noch {AMOUNT} bis zum kostenlosen Versand!', 'Noch {AMOUNT} bis zu 10 % Rabatt']
    }
  };
  /* etichette per screen reader e messaggi di errore (non sono nei setting) */
  var A = {
    it: { close: 'Chiudi carrello', remove: 'Rimuovi', minus: 'Diminuisci quantità', plus: 'Aumenta quantità', qty: 'Quantità',
      orig: 'Prezzo originale', sale: 'Prezzo scontato', price: 'Prezzo', savings: 'Risparmio', totalSavings: 'Risparmio totale',
      prev: 'Suggerimento precedente', next: 'Suggerimento successivo', error: 'Non siamo riusciti ad aggiornare il carrello. Riprova.', shop: 'Vai allo shop' },
    en: { close: 'Close cart', remove: 'Remove', minus: 'Decrease quantity', plus: 'Increase quantity', qty: 'Quantity',
      orig: 'Original price', sale: 'Sale price', price: 'Price', savings: 'Savings', totalSavings: 'Total savings',
      prev: 'Previous suggestion', next: 'Next suggestion', error: "We couldn't update your cart. Please try again.", shop: 'Go to the shop' },
    de: { close: 'Warenkorb schließen', remove: 'Entfernen', minus: 'Menge verringern', plus: 'Menge erhöhen', qty: 'Menge',
      orig: 'Ursprünglicher Preis', sale: 'Angebotspreis', price: 'Preis', savings: 'Ersparnis', totalSavings: 'Gesamtersparnis',
      prev: 'Vorheriger Vorschlag', next: 'Nächster Vorschlag', error: 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es noch einmal.', shop: 'Zum Shop' }
  };
  var AL = A[LOC] || A.it;
  var T = CFG.texts || {};
  var dict = LOC !== 'it' ? D[LOC] : null;
  function tx(key) { return (dict && dict[key] != null) ? dict[key] : T[key]; }
  function tierLabel(i) { var t = CFG.tiers[i]; return (dict && dict.tierLabel && dict.tierLabel[i] != null) ? dict.tierLabel[i] : t.label; }
  function tierBefore(i) { var t = CFG.tiers[i]; return (dict && dict.tierBefore && dict.tierBefore[i] != null) ? dict.tierBefore[i] : t.before; }

  var ICON = {
    close: '<svg class="upcart-header-close-button-icon styles_Header__closeButtonIcon__" viewBox="0 0 20 20"><path d="m11.414 10 6.293-6.293a1 1 0 1 0-1.414-1.414l-6.293 6.293-6.293-6.293a1 1 0 0 0-1.414 1.414l6.293 6.293-6.293 6.293a1 1 0 1 0 1.414 1.414l6.293-6.293 6.293 6.293a.998.998 0 0 0 1.707-.707.999.999 0 0 0-.293-.707l-6.293-6.293z"></path></svg>',
    shipping: '<svg viewBox="0 0 20 20"><path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path></svg>',
    tag: '<svg viewBox="0 0 20 20"><path d="M13 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path fill-rule="evenodd" d="M11.276 3.5a3.75 3.75 0 0 0-2.701 1.149l-4.254 4.417a2.75 2.75 0 0 0 .036 3.852l2.898 2.898a2.5 2.5 0 0 0 3.502.033l4.747-4.571a3.25 3.25 0 0 0 .996-2.341v-2.187a3.25 3.25 0 0 0-3.25-3.25h-1.974Zm-1.62 2.19a2.25 2.25 0 0 1 1.62-.69h1.974c.966 0 1.75.784 1.75 1.75v2.187c0 .475-.194.93-.536 1.26l-4.747 4.572a1 1 0 0 1-1.401-.014l-2.898-2.898a1.25 1.25 0 0 1-.016-1.75l4.253-4.418Z"></path></svg>',
    minus: '<svg viewBox="0 0 20 20"><path fill-rule="evenodd" d="M5 10c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75Z"></path></svg>',
    plus: '<svg viewBox="0 0 20 20"><path d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"></path></svg>',
    trash: '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.28125 3.28125L3.86719 12.6562C3.89502 13.1979 4.28906 13.5938 4.80469 13.5938H10.1953C10.713 13.5938 11.0997 13.1979 11.1328 12.6562L11.7188 3.28125" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.34375 3.28125H12.6562H2.34375Z" fill="#8F8F8F"></path><path d="M2.34375 3.28125H12.6562" stroke="#8F8F8F" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"></path><path d="M9.60938 5.15625L9.375 11.7188M5.625 3.28125V2.10938C5.62473 2.01697 5.64273 1.92541 5.67797 1.83998C5.71321 1.75455 5.76499 1.67693 5.83034 1.61159C5.89568 1.54624 5.9733 1.49446 6.05873 1.45922C6.14416 1.42398 6.23571 1.40598 6.32812 1.40625H8.67188C8.76429 1.40598 8.85584 1.42398 8.94127 1.45922C9.0267 1.49446 9.10432 1.54624 9.16966 1.61159C9.23501 1.67693 9.28679 1.75455 9.32203 1.83998C9.35727 1.92541 9.37527 2.01697 9.375 2.10938V3.28125H5.625ZM7.5 5.15625V11.7188V5.15625ZM5.39062 5.15625L5.625 11.7188L5.39062 5.15625Z" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
    arrow: '<svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.353516 0.840118L3.96848 4.76997L7.58344 0.840118L0.353516 0.840118Z" fill="#6F6F6F"></path></svg>',
    badge: '<svg viewBox="0 0 20 20"><path d="M13 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path fill-rule="evenodd" d="M11.276 3.5a3.75 3.75 0 0 0-2.701 1.149l-4.254 4.417a2.75 2.75 0 0 0 .036 3.852l2.898 2.898a2.5 2.5 0 0 0 3.502.033l4.747-4.571a3.25 3.25 0 0 0 .996-2.341v-2.187a3.25 3.25 0 0 0-3.25-3.25h-1.974Zm-1.62 2.19a2.25 2.25 0 0 1 1.62-.69h1.974c.966 0 1.75.784 1.75 1.75v2.187c0 .475-.194.93-.536 1.26l-4.747 4.572a1 1 0 0 1-1.401-.014l-2.898-2.898a1.25 1.25 0 0 1-.016-1.75l4.253-4.418Z"></path></svg>'
  };

  /* ---- util ---- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* formato della valuta attiva ricavato da un importo campione stampato da Shopify (es. "€ 1.234,56", "1.234,56 zł") */
  var FMT = (function () {
    var s = String(CFG.moneySample || '').replace(/\s+/g, ' ').trim();
    var a = s.search(/\d/), b = -1;
    for (var i = s.length - 1; i >= 0; i--) { if (/\d/.test(s.charAt(i))) { b = i; break; } }
    if (a < 0 || b < a) return { pre: (CFG.symbol || '€') + ' ', suf: '', thou: '.', dec: ',', decimals: 2 };
    var core = s.slice(a, b + 1);
    var mDec = core.match(/([.,])(\d{2})$/);
    var intPart = mDec ? core.slice(0, -3) : core;
    var mThou = intPart.match(/\D/);
    return { pre: s.slice(0, a), suf: s.slice(b + 1), thou: mThou ? mThou[0] : '', dec: mDec ? mDec[1] : '', decimals: mDec ? 2 : 0 };
  })();
  function money(cents) {
    var n = Math.round(Number(cents) || 0);
    var neg = n < 0; n = Math.abs(n);
    var units = FMT.decimals ? Math.floor(n / 100) : Math.round(n / 100);
    var whole = String(units).replace(/\B(?=(\d{3})+(?!\d))/g, FMT.thou);
    var dec = FMT.decimals ? FMT.dec + ('0' + (n % 100)).slice(-2) : '';
    return (neg ? '-' : '') + FMT.pre + whole + dec + FMT.suf;
  }
  function m(cents) { return '<span class="transcy-money">' + money(cents) + '</span>'; }
  function fill(str, map) { return String(str || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return map[k] != null ? map[k] : ''; }); }
  function imgUrl(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function getJSON(url) { return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), __sg: 1 })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---- stato ---- */
  var cart = null;
  var products = {};          // handle -> product json | false
  var upsellIdx = 0;
  var rootEl = null, isOpen = false, busy = false;
  var openTimer = null;
  var errMsg = '', errTimer = null;
  var lastFocus = null;

  /* soglie in euro (setting) -> centesimi nella valuta del mercato attivo */
  var RATE = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
  var TIERS = (CFG.tiers || []).filter(function (t) { return t && t.amount > 0; })
    .sort(function (a, b) { return a.amount - b.amount; });
  TIERS.forEach(function (t) { t.cents = Math.round(t.amount * 100 * RATE); });
  var hideRewards = !!(CFG.hideForB2b && CFG.b2b) && !/[?&]sg_cart_show_all\b/.test(location.search);

  /* ---- rewards ---- */
  function rewardsHtml(c, empty) {
    if (hideRewards || !CFG.barEnabled || !TIERS.length) return '';
    // come Shopify: la spedizione gratuita guarda il totale dopo gli sconti, lo sconto automatico il subtotale prima
    var base = function (t) { return t.kind === 'shipping' ? c.total_price : (c.original_total_price != null ? c.original_total_price : c.total_price); };
    var n = TIERS.length, k = 0;
    while (k < n && base(TIERS[k]) >= TIERS[k].cents) k++;
    var pct;
    if (k >= n) pct = 100;
    else {
      var prev = k ? TIERS[k - 1].cents : 0;
      var next = TIERS[k].cents;
      pct = ((k + Math.max(0, base(TIERS[k]) - prev) / (next - prev)) / n) * 100;
    }
    pct = Math.max(0, Math.min(100, pct));
    var msg;
    if (k >= n) msg = '<p>' + esc(tx('after')) + '</p>';
    else {
      var idx = TIERS.indexOf(TIERS[k]);
      var origIdx = CFG.tiers.indexOf(TIERS[k]);
      msg = '<p>' + esc(tierBefore(origIdx < 0 ? idx : origIdx)).replace('{AMOUNT}', m(TIERS[k].cents - base(TIERS[k]))) + '</p>';
    }
    var tiers = TIERS.map(function (t, i) {
      // colori in sg-upcart.css: livello raggiunto pieno nero, da raggiungere sabbia
      var reached = i < k;
      var pos = i < n - 1 ? 'exactlyCenter' : 'leftOfCenter';
      var oi = CFG.tiers.indexOf(t);
      return '<div class="upcart-rewards-tier styles_TieredRewards__tierCircleAndDescription__ styles_TieredRewards__tierCircleAndDescription--' + pos + '__' + (reached ? ' sg-tier--on' : '') + '">' +
        '<div class="upcart-rewards-tier-circle styles_TieredRewards__tierCircle__"><div class="upcart-rewards-tier-icon">' +
        (t.kind === 'shipping' ? ICON.shipping : ICON.tag) + '</div></div>' +
        '<div class="upcart-rewards-tier-description styles_rewardsDescription__">' + esc(tierLabel(oi < 0 ? i : oi)) + '</div></div>';
    }).join('');
    return '<div><div class="upcart-rewards styles_TieredRewards__ UpcartDesignSettings__cartTextColor">' +
      '<div class="upcart-rewards-message">' + msg + ' </div>' +
      '<div class="upcart-rewards-bar-background styles_TieredRewards__progressBar__">' +
      '<div class="upcart-rewards-bar-foreground styles_Rewards__progressBar--progress__" style="width: ' + pct.toFixed(4) + '%;"></div></div>' +
      '<div class="styles_TieredRewards__tiersContainer__"><div></div>' + tiers + '</div></div></div>';
  }

  /* ---- righe ---- */
  function badgeHtml(title) {
    return '<div class="upcart-discount-code-badge DiscountCodeBadge_discountBadge__"><div class="upcart-discount-code-icon DiscountCodeBadge_icon__">' + ICON.badge + '</div><span class="upcart-discount-code-text DiscountCodeBadge_title__">' + esc(title) + '</span></div>';
  }
  function compareFor(item) {
    var p = products[item.handle];
    if (!p || !p.variants) return 0;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].id === item.variant_id) return p.variants[i].compare_at_price || 0;
    }
    return 0;
  }
  function itemHtml(item) {
    var opts = '';
    if (!item.product_has_only_default_variant && item.options_with_values) {
      opts = item.options_with_values.map(function (o) {
        /* alcuni prodotti hanno il nome opzione gia' con i due punti ("Gusto:") */
        var name = String(o.name || '').replace(/\s*:\s*$/, '');
        return '<div class="upcart-item-option"><span class="TextStyle--variationSubdued UpcartDesignSettings__cartTextSubduedColor"><span class="upcart-item-option-category">' + esc(name) + ': </span><span class="upcart-item-option-value">' + esc(o.value) + '</span></span></div>';
      }).join('');
    }
    var props = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        if (k.charAt(0) === '_' || item.properties[k] === '' || item.properties[k] == null) return;
        props += '<div class="upcart-item-option"><span class="TextStyle--variationSubdued UpcartDesignSettings__cartTextSubduedColor"><span class="upcart-item-option-category">' + esc(k) + ': </span><span class="upcart-item-option-value">' + esc(item.properties[k]) + '</span></span></div>';
      });
    }
    var orig = item.original_line_price, fin = item.final_line_price;
    var cmp = compareFor(item) * item.quantity;
    var showCompare = orig > fin ? orig : (cmp > fin ? cmp : 0);
    var saved = showCompare ? showCompare - fin : 0;
    var titles = (item.discounts || []).map(function (d) { return d.title; });
    var price = '<div class="upcart-item-prices-row styles_ProductRow__priceRow__">' +
      (showCompare ? '<span class="upcart-internal__visually-hidden">' + esc(AL.orig) + '</span><span class="upcart-do-not-modify-this-node-please-only-modify-child-node"><span class="upcart-item-compare-price upcart-price-compare styles_Price__compareAtPrice__ UpcartDesignSettings__cartTextSubduedColor">' + m(showCompare) + '</span></span><span class="upcart-internal__visually-hidden">' + esc(AL.sale) + '</span>' : '<span class="upcart-internal__visually-hidden">' + esc(AL.price) + '</span>') +
      '<span class="upcart-do-not-modify-this-node-please-only-modify-child-node"><span class="upcart-item-price UpcartDesignSettings__cartTextColor styles_ProductRow__ProductPrice__">' + m(fin) + '</span></span></div>';
    if (saved > 0) {
      price += '<span class="upcart-internal__visually-hidden">' + esc(AL.savings) + '</span><span class="upcart-do-not-modify-this-node-please-only-modify-child-node"><span class="upcart-product-savings styles_ProductRow__cartDiscountFormat__ UpcartDesignSettings__cartSavingsTextColor">(' + esc(tx('save')) + ' ' + m(saved) + ')</span></span>';
      price += titles.map(badgeHtml).join('');
    }
    return '<div class="styles_ProductRow__product__ upcart-product-item " id="' + esc(item.key) + '" data-key="' + esc(item.key) + '">' +
      '<div class="Stack Stack--distributionLeading Stack--spacingLoose"><div class="Stack__item"><div class="upcart-product-image-wrapper styles_ProductRow__imageWrapper__"><a href="' + esc(item.url) + '" data-no-pointer="false" aria-label="' + esc(item.title) + '">' +
      (item.featured_image && item.featured_image.url ? '<img src="' + esc(imgUrl(item.featured_image.url, 240)) + '" alt="' + esc(item.title) + '">' : '') + '</a></div></div>' +
      '<div class="Stack__item Stack__item--fill"><div class="styles_ProductRow__productHeading__"><div class="styles_ProductRow__productTitleAndVariant__">' +
      '<h3 class="upcart-product-title UpcartDesignSettings__cartTextColor styles_ProductRow__productTitle__"><a class="upcart-product-title-link styles_ProductRow__productTitleLink__" href="' + esc(item.url) + '" data-no-pointer="false">' + esc(item.product_title) + '</a></h3>' +
      opts + props + '</div><div><div class="styles_TrashButton__deleteButton__" role="button" tabindex="0" data-sg-act="remove" aria-label="' + esc(AL.remove) + '">' + ICON.trash + '</div></div></div>' +
      '<div><div class="Stack Stack--distributionEqualSpacing Stack--alignmentCenter"><div class="Stack__item"><div class="styles_ProductRow__stepper__" style="border-radius: var(--upcart-internal-global-button-border-radius);"><div class="styles_QuantityField__">' +
      '<button type="button" class="upcart-product-quantity-minus styles_button__ styles_quantityMinus__" aria-label="' + esc(AL.minus) + '" data-sg-act="minus" style="border-top-left-radius: var(--upcart-internal-global-button-border-radius); border-bottom-left-radius: var(--upcart-internal-global-button-border-radius);">' + ICON.minus + '<span class="upcart-internal-visually-hidden">' + esc(AL.minus) + '</span></button>' +
      '<input class="upcart-product-quantity-input js-qty__num styles_quantityInput__" maxlength="4" aria-label="' + esc(AL.qty) + '" type="number" min="0" max="9999" value="' + item.quantity + '" data-sg-act="qty">' +
      '<button type="button" class="upcart-product-quantity-plus styles_button__ styles_quantityPlus__" aria-label="' + esc(AL.plus) + '" data-sg-act="plus" style="border-top-right-radius: var(--upcart-internal-global-button-border-radius); border-bottom-right-radius: var(--upcart-internal-global-button-border-radius);">' + ICON.plus + '<span class="upcart-internal-visually-hidden">' + esc(AL.plus) + '</span></button>' +
      '</div></div></div><div class="Stack__item" style="margin-left: auto;"><div class="styles_ProductRow__price__">' + price + '</div></div></div></div></div></div></div>';
  }

  /* ---- upsell ---- */
  function parseRules() {
    var rules = { triggers: {}, all: [] };
    String(CFG.upsellRules || '').split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf(':'); if (i < 1) return;
      var key = line.slice(0, i).trim().toLowerCase();
      var list = line.slice(i + 1).split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      if (key === '*') rules.all = rules.all.concat(list);
      else rules.triggers[key] = (rules.triggers[key] || []).concat(list);
    });
    return rules;
  }
  var RULES = parseRules();
  function upsellHandles(c) {
    var inCart = {}; c.items.forEach(function (it) { inCart[it.handle] = 1; });
    var out = [];
    c.items.forEach(function (it) { (RULES.triggers[it.handle] || []).forEach(function (h) { out.push(h); }); });
    RULES.all.forEach(function (h) { out.push(h); });
    var seen = {};
    out = out.filter(function (h) { if (seen[h] || inCart[h]) return false; seen[h] = 1; return true; });
    return out.slice(0, Math.max(1, CFG.upsellMax || 10));
  }
  function loadProduct(h) {
    if (h in products) return Promise.resolve(products[h]);
    return getJSON(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(function (p) { products[h] = p; return p; }, function () { products[h] = false; return false; });
  }
  /* prezzo del suggerito, con il prezzo pieno barrato quando la variante e' scontata (come UpCart) */
  function upsellPriceHtml(v) {
    var cmp = Number(v.compare_at_price) || 0;
    return (cmp > v.price ? '<span class="upcart-upsell-item-compare-price styles_PreviewCarousel__itemPrice--discount__ UpcartDesignSettings__cartTextSubduedColor upcart-default-price">' + money(cmp) + '</span>' : '') +
      '<span class="upcart-upsell-item-price UpcartDesignSettings__cartTextColor upcart-discount-price"><span class="transcy-money">' + money(v.price) + '</span></span>';
  }
  function upsellHtml(c) {
    if (hideRewards || !CFG.upsellEnabled) return '';
    var list = upsellHandles(c).map(function (h) { return products[h]; }).filter(function (p) { return p && p.available; });
    if (!list.length) return '';
    if (upsellIdx >= list.length) upsellIdx = 0;
    var slides = list.map(function (p, i) {
      // varianti disponibili, dalla piu' economica (default selezionato = prezzo mostrato)
      var vars = p.variants.filter(function (v) { return v.available; }).sort(function (a, b) { return a.price - b.price; });
      var img = (p.featured_image || (p.images && p.images[0])) || '';
      var first = vars[0];
      return '<li class="slide' + (i === upsellIdx ? ' selected' : '') + '"><div class="upcart-upsell-item-card styles_PreviewCarousel__item__ UpcartDesignSettings__cartAccentColor upcart-upsells"><div class="Stack Stack--noWrap "><div class="Stack__item" data-internal-properties="isImageForUpsellWithRating=false"><div class="upcart-upsell-item-image-wrapper styles_PreviewCarousel__imageWrapper__"><a href="' + esc(p.url || '#') + '">' + (img ? '<img class="upcart-upsell-item-image" src="' + esc(imgUrl(img, 300)) + '" alt="' + esc(p.title) + '">' : '') + '</a></div></div>' +
        '<div class="Stack__item Stack__item--fill"><div class="styles_PreviewCarousel__itemTitle__"><a href="' + esc(p.url) + '" class="variationStrong UpcartDesignSettings__cartTextColor"><h3 class="upcart-upsell-item-title styles_itemTitle__">' + esc(p.title) + '</h3></a><span class="upcart-upsell-item-price-row styles_PreviewCarousel__itemPrice__">' + upsellPriceHtml(first) + '</span></div>' +
        '<form data-sg-upsell="' + esc(p.handle) + '"><div class="styles_PreviewCarousel__variationProduct__"><div class="styles_PreviewCarousel__selectWrapper__"><select class="upcart-upsell-item-variant-selector styles_PreviewCarousel__select__" title="productVariant" name="productVariant">' +
        vars.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || 0) + '">' + esc(v.title) + '</option>'; }).join('') +
        '</select><div class="styles_SelectArrow__">' + ICON.arrow + '</div></div><div class="styles_PreviewCarousel__inputWrapper__"><input type="submit" class="upcart-upsells-button styles_PreviewCarousel__button__ UpcartDesignSettings__button" value="' + esc(tx('add')) + '"></div></div></form></div></div></div></li>';
    }).join('');
    var arrows = list.length > 1;
    return '<div class="styles_CartPreview__bottomModules__"><div><div id="up-upsell-carousel" class="upcart-upsells-module styles_PreviewCarousel__">' +
      '<h2 class="upcart-upsells-title UpcartDesignSettings__cartTextColor styles_title__"><p>' + esc(tx('upsellTitle')) + '</p> </h2>' +
      '<div class="carousel-root"><div class="carousel carousel-slider" style="width: 100%;">' +
      (arrows ? '<button type="button" aria-label="' + esc(AL.prev) + '" class="control-arrow control-prev" data-sg-act="prev"></button>' : '') +
      '<div class="slider-wrapper axis-horizontal"><ul class="slider animated" style="transform: translate3d(-' + (upsellIdx * 100) + '%, 0px, 0px); transition-duration: 350ms;">' + slides + '</ul></div>' +
      (arrows ? '<button type="button" aria-label="' + esc(AL.next) + '" class="control-arrow control-next" data-sg-act="next"></button>' : '') +
      '</div></div></div></div></div>';
  }

  /* ---- footer ---- */
  function footerHtml(c) {
    var titles = [], seen = {};
    c.items.forEach(function (it) { (it.discounts || []).forEach(function (d) { if (!seen[d.title]) { seen[d.title] = 1; titles.push(d.title); } }); });
    (c.cart_level_discount_applications || []).forEach(function (d) { if (!seen[d.title]) { seen[d.title] = 1; titles.push(d.title); } });
    var sav = '';
    if (c.total_discount > 0) {
      sav = '<div class="upcart-savings-row styles_Footer__savings__"><div class="styles_Footer__savingsCodes__"><span class="UpcartDesignSettings__cartTextColor">' + esc(tx('discounts')) + '</span><div class="styles_Footer__slidingCodes__">' + titles.map(badgeHtml).join('') + '</div></div>' +
        '<span class="upcart-internal__visually-hidden">' + esc(AL.totalSavings) + '</span><span class="upcart-savings-amount UpcartDesignSettings__cartTextColor">- ' + m(c.total_discount) + '</span></div>';
    }
    var label = fill(tx('checkout'), { total_price: money(c.total_price) }).replace(money(c.total_price), '<span class="transcy-money">' + money(c.total_price) + '</span>');
    return '<div><div class="styles_Footer__ UpcartDesignSettings__cartAccentColor upcart-footer">' + sav +
      '<div class="styles_Footer__checkoutButton__"><div class="upcart-checkout-button-container styles_CustomButton__ "><a href="' + esc(CFG.checkoutUrl || '/checkout') + '" class="styles_CustomButton__fullWidth__ styles_CustomButton__fullHight__ UpcartDesignSettings__button upcart-checkout-button" data-disable-recharge="true">' + label + '</a></div></div></div></div>';
  }

  function headerHtml(c) {
    var t = fill(tx(c.item_count === 1 && tx('titleOne') ? 'titleOne' : 'title'), { cart_quantity: c.item_count });
    return '<div><div class="styles_Header__ UpcartDesignSettings__cartTextColor upcart-header"><h4 class="upcart-header-text" tabindex="0" aria-label="' + esc(t) + '">' + esc(t) + '</h4>' +
      '<div class="upcart-header-close-button styles_Header__closeButton__" role="button" aria-label="' + esc(AL.close) + '" tabindex="0" data-sg-act="close">' + ICON.close + '</div></div></div>';
  }

  function errorHtml() { return errMsg ? '<div class="sg-upcart-error" role="alert">' + esc(errMsg) + '</div>' : ''; }
  function errText(err) {
    if (err && typeof err.description === 'string' && err.description) return err.description;
    return AL.error;
  }
  /* errore di Shopify (es. quantita' oltre la giacenza) mostrato in alto nel drawer per qualche secondo */
  function setError(msg) {
    errMsg = msg || '';
    clearTimeout(errTimer);
    if (errMsg) errTimer = setTimeout(function () { errMsg = ''; render(); }, 7000);
  }

  function cardHtml(c) {
    if (!c.items.length) {
      return '<div class="styles_CartPreview__card__"><div>' + headerHtml(c).replace(/^<div>|<\/div>$/g, '') + errorHtml() + rewardsHtml(c, true) + '</div>' +
        '<div class="styles_CartPreview__empty__body__" style="flex-grow: 1; overflow-y: auto;"><div class="styles_CartPreview__empty__"><h3>' + esc(tx('empty')) + '</h3>' +
        '<a class="sg-upcart-empty-cta" href="' + esc(ROOT + 'collections/catalogo') + '">' + esc(AL.shop) + '</a></div></div></div>';
    }
    return '<div class="styles_CartPreview__card__">' + headerHtml(c) + errorHtml() +
      '<div class="upcart-cart-body styles_CartPreview__body__" style="flex-grow: 1; overflow-y: auto;"><div> </div>' + rewardsHtml(c) +
      '<div><div id="sg-stock-note"></div></div>' +
      '<div class="upcart-products-section">' + c.items.map(itemHtml).join('') + '</div>' + upsellHtml(c) + '</div>' + footerHtml(c) + '</div>';
  }

  /* ---- render / apertura ---- */
  function ensureRoot() {
    if (rootEl) return rootEl;
    rootEl = document.createElement('div');
    rootEl.id = 'UpcartPopup';
    rootEl.className = 'upcartPopupShow';
    rootEl.innerHTML = '<div class="upcart-backdrop styles_CartPreview__backdrop__" id="UpcartPopupBackDrop" data-sg-act="close"></div>' +
      '<div id="CartPopup" class="upcart-cart styles_CartPreview__ styles_CartPreview__right__ styles_CartPreview__position-fixed__ UpcartDesignSettings__backgroundColor upcart-internal-cart-preview__container" data-scrollable="true" tabindex="-1" role="dialog" aria-modal="true"></div>';
    document.body.appendChild(rootEl);
    rootEl.addEventListener('click', onClick);
    rootEl.addEventListener('change', onChange);
    rootEl.addEventListener('submit', onSubmit);
    rootEl.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.getAttribute && /^(close|remove)$/.test(e.target.getAttribute('data-sg-act') || '')) { e.preventDefault(); e.target.click(); } });
    return rootEl;
  }
  function render() {
    if (!cart) return;
    var r = ensureRoot();
    var pop = r.querySelector('#CartPopup');
    var body = pop.querySelector('.upcart-cart-body');
    var scroll = body ? body.scrollTop : 0;
    var note = pop.querySelector('#sg-stock-note');
    var noteCls = note ? note.className : '', noteHtml = note ? note.innerHTML : '', noteHidden = note ? note.hidden : false;
    pop.innerHTML = cardHtml(cart);
    var n2 = pop.querySelector('#sg-stock-note');
    if (n2 && noteHtml) { n2.className = noteCls; n2.innerHTML = noteHtml; n2.hidden = noteHidden; n2.setAttribute('data-sg-seen', '1'); }
    var b2 = pop.querySelector('.upcart-cart-body'); if (b2) b2.scrollTop = scroll;
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    // carica le anagrafiche mancanti (compare-at, upsell) e ridisegna una volta
    var need = [];
    cart.items.forEach(function (it) { if (!(it.handle in products)) need.push(it.handle); });
    if (!hideRewards && CFG.upsellEnabled) upsellHandles(cart).forEach(function (h) { if (!(h in products)) need.push(h); });
    need = need.filter(function (h, i) { return need.indexOf(h) === i; });
    if (need.length) Promise.all(need.map(loadProduct)).then(function () { if (cart) render(); });
  }
  function setOpenState(v) {
    var r = ensureRoot();
    var was = isOpen;
    if (v && !was) lastFocus = document.activeElement;
    isOpen = v;
    r.querySelector('#CartPopup').classList.toggle('styles_active__', v);
    r.querySelector('#UpcartPopupBackDrop').classList.toggle('styles_active__', v);
    document.documentElement.classList.toggle('sg-upcart-lock', v);
    if (v) { try { r.querySelector('#CartPopup').focus({ preventScroll: true }); } catch (e) {} document.dispatchEvent(new CustomEvent('upcart:open')); }
    else if (was) {
      if (errMsg) { setError(''); render(); }
      if (lastFocus && lastFocus.focus && document.documentElement.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
      lastFocus = null;
    }
  }
  function refresh() {
    return getJSON(ROOT + 'cart.js?_=' + Date.now()).then(function (c) { cart = c; render(); refreshBubble(); return c; });
  }
  function open() {
    ensureRoot();
    var p = cart ? Promise.resolve() : refresh();
    return p.then(function () { render(); // forza il browser a registrare lo stato chiuso prima di aprire (animazione)
      var pop = rootEl.querySelector('#CartPopup'); void pop.offsetWidth; setOpenState(true); refresh(); });
  }
  function close() { if (rootEl) setOpenState(false); }
  function refreshAndOpen() { return refresh().then(function () { var pop = ensureRoot().querySelector('#CartPopup'); void pop.offsetWidth; setOpenState(true); }); }
  function refreshBubble() {
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return;
    fetch(ROOT + '?sections=cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (s) {
      var h = s && s['cart-icon-bubble']; if (!h) return;
      var d = document.createElement('div'); d.innerHTML = h;
      var src = d.querySelector('.shopify-section') || d;
      el.innerHTML = src.innerHTML;
    }).catch(function () {});
  }

  /* ---- azioni ---- */
  function setBusy(v) { busy = v; if (rootEl) rootEl.querySelector('#CartPopup').classList.toggle('sg-busy', v); }
  function change(key, qty) {
    setBusy(true);
    setError('');
    return post(ROOT + 'cart/change.js', { id: key, quantity: qty }).then(function (c) { cart = c; }).catch(function (err) { setError(errText(err)); })
      .then(function () { return refresh(); }).then(function () { setBusy(false); }, function () { setBusy(false); });
  }
  function addVariant(id, qty) {
    setBusy(true);
    setError('');
    return post(ROOT + 'cart/add.js', { items: [{ id: Number(id), quantity: qty || 1 }] }).catch(function (err) { setError(errText(err)); })
      .then(function () { return refresh(); }).then(function () { setBusy(false); }, function () { setBusy(false); });
  }
  function itemOf(el) { var row = el.closest('.upcart-product-item'); return row ? cart.items.filter(function (i) { return i.key === row.getAttribute('data-key'); })[0] : null; }
  function slideTo(delta) {
    var ul = rootEl.querySelector('.slider'); if (!ul) return;
    var n = ul.children.length; upsellIdx = (upsellIdx + delta + n) % n;
    ul.style.transform = 'translate3d(-' + (upsellIdx * 100) + '%, 0px, 0px)';
    [].forEach.call(ul.children, function (li, i) { li.classList.toggle('selected', i === upsellIdx); });
  }
  function onClick(e) {
    var t = e.target.closest ? e.target.closest('[data-sg-act]') : null; if (!t) return;
    var act = t.getAttribute('data-sg-act');
    if (act === 'close') { close(); return; }
    if (act === 'prev') { slideTo(-1); return; }
    if (act === 'next') { slideTo(1); return; }
    var it = itemOf(t); if (!it) return;
    if (act === 'remove') change(it.key, 0);
    else if (act === 'minus') change(it.key, Math.max(0, it.quantity - 1));
    else if (act === 'plus') change(it.key, it.quantity + 1);
  }
  function onChange(e) {
    var t = e.target;
    if (t.matches && t.matches('.upcart-upsell-item-variant-selector')) {
      var opt = t.options[t.selectedIndex];
      var row = t.closest('.upcart-upsell-item-card').querySelector('.upcart-upsell-item-price-row');
      if (row && opt) row.innerHTML = upsellPriceHtml({ price: Number(opt.getAttribute('data-price')), compare_at_price: Number(opt.getAttribute('data-compare')) });
      return;
    }
    if (t.getAttribute && t.getAttribute('data-sg-act') === 'qty') {
      var it = itemOf(t); if (!it) return;
      var q = parseInt(t.value, 10); if (isNaN(q) || q < 0) q = it.quantity;
      change(it.key, q);
    }
  }
  function onSubmit(e) {
    var f = e.target.closest ? e.target.closest('form[data-sg-upsell]') : null; if (!f) return;
    e.preventDefault();
    var sel = f.querySelector('select'); if (sel) addVariant(sel.value, 1);
  }

  /* ---- ganci esterni: icona carrello, aggiunta dal sito ---- */
  var cartPathRe = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i;
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    if (a.closest('#UpcartPopup')) return;
    var href = a.getAttribute('href') || '';
    var path; try { path = new URL(href, location.href).pathname; } catch (err) { return; }
    if (!(a.id === 'cart-icon-bubble' || cartPathRe.test(path))) return;
    if (cartPathRe.test(location.pathname)) return; // gia' sulla pagina carrello
    if (/\/cart\/(add|change|clear)/.test(href)) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    open();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    /* il focus resta nel drawer finche' e' aperto */
    var pop = rootEl.querySelector('#CartPopup');
    var list = [].filter.call(pop.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.getClientRects().length > 0; });
    if (!list.length) { e.preventDefault(); pop.focus(); return; }
    var first = list[0], last = list[list.length - 1], a = document.activeElement;
    if (!pop.contains(a)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && (a === first || a === pop)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  });

  function onAdded() {
    clearTimeout(openTimer);
    openTimer = setTimeout(function () { if (!busy) refreshAndOpen(); }, 120);
  }
  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
      var mine = init && init.__sg;
      var p = _fetch.apply(this, arguments);
      if (!mine && /\/cart\/add(\.js)?(\?|$)/.test(url)) p.then(function (r) { if (r && r.ok) onAdded(); }, function () {});
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this.__sgAdd = /\/cart\/add(\.js)?(\?|$)/.test(String(url)); return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__sgAdd) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) onAdded(); });
    return _send.apply(this, arguments);
  };

  /* Form nativi verso /cart/add (es. landing con <product-form> senza il JS di Dawn): UpCart li faceva in Ajax,
     qui lo stesso. Ascolto su window in bolla, quindi dopo i gestori del sito: chi fa gia' Ajax chiama preventDefault. */
  var addPathRe = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/add\/?$/i;
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f || f.tagName !== 'FORM' || (rootEl && rootEl.contains(f))) return;
    var path; try { path = new URL(f.getAttribute('action') || '', location.href).pathname; } catch (x) { return; }
    if (!addPathRe.test(path) || String(f.getAttribute('method') || 'get').toLowerCase() !== 'post') return;
    e.preventDefault();
    if (f.__sgAdding) return; // doppio clic
    f.__sgAdding = true;
    var fd = new FormData(f);
    if (e.submitter && e.submitter.name && !fd.has(e.submitter.name)) fd.append(e.submitter.name, e.submitter.value);
    var btn = e.submitter || f.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var done = function () { f.__sgAdding = false; if (btn) btn.removeAttribute('aria-busy'); };
    fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd, __sg: 1 })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        done();
        setError(res.ok ? '' : errText(res.j));
        refreshAndOpen();
      }, function () {
        /* rete o risposta illeggibile: invio normale del form (porta alla pagina carrello) */
        done();
        HTMLFormElement.prototype.submit.call(f);
      });
  });

  /* Drawer Dawn (settings.cart_type = drawer): resta nel DOM ma nascosto dal CSS. Chi lo apre o lo aggiorna
     (product-form, quick add, icona da tastiera) apre questo drawer. */
  function patchDawnDrawer() {
    var C = window.customElements && window.customElements.get('cart-drawer');
    if (!C || C.prototype.__sgPatched) return;
    C.prototype.__sgPatched = true;
    C.prototype.open = function () { open(); };
    C.prototype.renderContents = function () { onAdded(); };
  }
  if (window.customElements && window.customElements.whenDefined) window.customElements.whenDefined('cart-drawer').then(patchDawnDrawer);

  window.sgUpcart = { open: open, close: close, refresh: refresh, refreshAndOpen: refreshAndOpen, added: onAdded, render: render, config: CFG, tiers: function () { return TIERS.slice(); } };
})();
